import React, { useState } from 'react';
import { Slider, Button, Input, Select, TextArea, Toast, Tooltip, DragDrop, MultiSelectCheckBox, Attachment } from '@kaleyra/emmy';
import { useTranslation } from "react-i18next";
import Styles from './index.module.scss';
import { isEmpty } from 'lodash';
import { getcharcount, validateOnlyNumbers, validateURL } from '../../../../../../utils';
import DownloadIcon from '../../../../../../assets/downloadIconBlue.svg';

type SenderIdPropType = {
}

type OptionType = {
    key: string;
    value: string;
}

type OptionTypeLabel = {
    label: string;
    value: string;
}


type tabOptionstype = "import" | "new";

export type MapStateType = {
    data: any;
    senderIdList: any;
    userProfile: any;
};

export type DispatchPropsType = {
    onClose: () => void;
    onSave: (applyTemplateData: any, callback: (resp: any, flag: boolean) => void) => void;
    onShortenUrl: (urlOb: any, callback: (resp: any, flag: boolean) => void) => void;
    onFileShortener: (payload: any, callback: (resp: any, flag: boolean) => void) => void;
    onLoad: () => void;
    onLoadData: () => void;
    onBulkUploadSave: (bulkUploadData: any, callback: (resp: any, flag: boolean) => void) => void;
};

const TemplateApplyForm: React.FC<SenderIdPropType & DispatchPropsType & MapStateType> = ({
    onClose, onSave, onShortenUrl, onLoad, data, onFileShortener, onLoadData, senderIdList, onBulkUploadSave, userProfile
}) => {

    const { t } = useTranslation();
    const { country_id } = userProfile.fullProfile;

    const [showSideModal, setShowSideModal] = useState(false);
    const [title, setTitle] = useState('');
    const [templateId, setTemplateId] = useState('');
    const [purpose, setPurpose] = useState<any>(undefined);
    const [senderId, setSenderId] = useState<any>(undefined);
    const [textContent, setTextContent] = useState('');
    const [urlShortenerText, setUrlShortenerText] = useState('');
    const [selectedTab, setSelectedTab] = useState<tabOptionstype>("import");
    const [uploadedFile, setUploadedFile] = useState<any>([]);
    const [importMultiselectValue, setImportMultiselectValue] = useState<string[]>([]);
    const [textareaCharCount, setTextareaCharCount] = useState<number>(0);
    const [messageUnitsCount, setMessageUnitsCount] = useState<number>(1);

    const isIndiaUser = !isEmpty(data.smsTemplatesData) &&
        Boolean(data.smsTemplatesData.is_India) &&
        (data.smsTemplatesData.is_India).toString() === "1";

    const getMainFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" onClick={onClose}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" disabled={handleDisabledStatus()} onClick={() => handleTemplateApply()}>
                    {t('mainSave')}
                </Button>
            </div>
        );
    };

    const handleDisabledStatus = (): boolean => {
        if (selectedTab === "import") {
            return (Boolean(uploadedFile.length === 0));
        } else {
            return false;
        }
    }

    const getSenderIdOptions = (): OptionTypeLabel[] => {
        let options: OptionTypeLabel[] = [];
        if (!isEmpty(data.smsTemplatesData) && data.smsTemplatesData.sender_array) {
            Object.keys(data.smsTemplatesData.sender_array).forEach((key: string) => {
                options.push({
                    label: key?.replace(/ /g, "\u00A0"),
                    value: data.smsTemplatesData.sender_array[key]?.replace(/ /g, "\u00A0")
                })
            })
        }
        return options;
    }

    const getURLShortenerFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" onClick={() => { setUrlShortenerText(''); setShowSideModal(false) }}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" onClick={() => handleURLShortener()} disabled={!isValidUrl()}>
                    {t('mainSave')}
                </Button>
            </div>
        );
    };

    const callback = (response: any, flag: boolean) => {
        if (flag && isEmpty(response.error)) {
            Toast(response.message, 'success');
            onClose();
            onLoad();
            if (!isEmpty(data.smsTemplatesData) && data.smsTemplatesData.data.length === 0) {
                onLoadData();
            }
        } else if (!isEmpty(response.error)) {
            Object.keys(response.error).forEach((key: any) => {
                Toast(response.error[key], 'error');
            });
        } else {
            Toast(response.message || response.data.message, 'error');
        }
    }

    const urlShortenerCallback = (response: any, flag: boolean) => {
        if (flag && response.data) {
            Toast(response.message, 'success');
            setShowSideModal(false);
            let content = textContent;
            content = (content.trim() + ' ' + response.data.shortLink).trim();
            setTextContent(content);
            setUrlShortenerText('');
        } else {
            Toast(response?.message, 'error');
        }

    }

    const fileShortenerCallback = (response: any, flag: boolean) => {
        if (flag && !isEmpty(response.data)) {
            Toast(response.message, 'success');
            const fileUrl = response.data[0].shortLink
            let content = textContent;
            content = (content.trim() + ' ' + fileUrl).trim();
            setTextContent(content);
        } else {
            Toast(response.data?.message, 'error');
        }
    }

    const senderIdOption = (): OptionType[] => {
        let options: OptionType[] = [];
        if (!isEmpty(data.smsTemplatesData) && data.smsTemplatesData.sender_array) {
            Object.keys(data.smsTemplatesData.sender_array).forEach((key: string) => {
                options.push({
                    key: key?.replace(/ /g, "\u00A0"),
                    value: data.smsTemplatesData.sender_array[key]?.replace(/ /g, "\u00A0")
                })
            })
        }
        return options;
    }

    const purposeOption = (): OptionType[] => {
        let options: OptionType[] = [];
        if (!isEmpty(data.smsTemplatesData) && data.smsTemplatesData.routes) {
            Object.keys(data.smsTemplatesData.routes).forEach((key: string) => {
                options.push({
                    key: key?.replace(/ /g, "\u00A0"),
                    value: data.smsTemplatesData.routes[key]?.replace(/ /g, "\u00A0")
                })
            })
        }
        return options;
    }

    const handleTemplateApply = () => {
        if (selectedTab === "new") {
            if (title === "") {
                Toast("Template title is required", "error");
                return;
            }
            if (purpose === undefined) {
                Toast("Template purpose is required", "error");
                return;
            }
            if (textContent === '') {
                Toast("Template content is required", "error");
                return;
            }
            if (templateIdStatus() === "error") {
                Toast("Numeric Template ID is allowed and it can only contain a minimum of 12 digits and maximum of 30 digits.", "error");
                return;
            }
            const formatApplyPayload = {
                activity_log_action: "Created",
                activity_log_object: "SMS TEMPLATE",
                activity_log_object_value: title,
                data: [
                    {
                        title: title,
                        purpose: purpose ? purpose.key : undefined,
                        sender_id: senderId ? senderId.key : undefined,
                        template_id: templateId !== "" ? templateId : undefined,
                        content: textContent,
                        
                    }
                ]
            }
            onSave(formatApplyPayload, callback)
        } else if (selectedTab === "import") {
            const formData = new FormData();
            formData.append('file', uploadedFile[0]);
            if (importMultiselectValue.length > 0) {
                formData.append('default_senders', (JSON.stringify({ senders: importMultiselectValue.toString() })));
            }
            onBulkUploadSave(formData, callback);
        } else {
            return;
        }

    }

    const handleURLShortener = () => {
        const formatPayload = {
            data: [
                {
                    url: urlShortenerText,
                    title: "1",
                    status: 1,
                    is_advanced: 1,
                }
            ]
        }
        onShortenUrl(formatPayload, urlShortenerCallback);
    }

    const handleAttachFile = (file: any) => {
        const formData = new FormData();
        formData.append('is_advanced', "1");
        formData.append('document_ids', file);
        onFileShortener(formData, fileShortenerCallback)
    }

    const templateIdStatus = (): "default" | "error" => {
        return (templateId === '' || (templateId?.length >= 12 && templateId?.length <= 30) && validateOnlyNumbers(templateId)) ? "default" : "error"
    }

    const isValidUrl = () => {
        return validateURL('url', urlShortenerText)
    }

    const purposeTooltipBody = () => {
        return (
            !isEmpty(data.smsTemplatesData) && data.smsTemplatesData.routes && <div className={Styles.tooltipWrapper}>
                <span className={Styles.tooltipTitle}>
                    Purpose chosen defines the approval process
                </span>
                <div className={Styles.tooltipListWrapper}>
                    <ul>
                        {data.smsTemplatesData.routes["MKT"] && <li>Marketing - Instant Approval</li>}
                        {data.smsTemplatesData.routes["TXN"] && <li>Transaction - Requires approval in certain countries</li>}
                        {data.smsTemplatesData.routes["TXND"] && <li>Transaction DND - Requires approval in certain countries</li>}
                        {data.smsTemplatesData.routes["OTP"] && <li>OTP - Requires Approval</li>}
                        {data.smsTemplatesData.routes["M2M"] && <li>M2M - Instant Approval</li>}
                        {data.smsTemplatesData.routes["DEFAULT"] && <li>Default - Instant Approval</li>}
                    </ul>
                </div>
            </div>
        )
    }

    const selectTabBody = () => {
        switch (selectedTab) {
            case "new":
                return getBody()
            case "import":
                return importBody();
            default:
                return <></>;
        }
    }

    const downloadSampleReport = () => {
        const sampleFileUrlIndianUser = process.env.REACT_APP_SAMPLE_INDIAN_TEMPLATE || "#";   
        const sampleFileUrlNonIndianUser = process.env.REACT_APP_SAMPLE_NON_INDIAN_TEMPLATE || "#"; 
        let sampleFileUrl = sampleFileUrlIndianUser;
        if (country_id === 277 || ((localStorage.getItem('KLR_USER_POD') === "IN"))) {
            sampleFileUrl = sampleFileUrlIndianUser
        } else {
            sampleFileUrl = sampleFileUrlNonIndianUser;
        }
        var a = document.createElement("a");
        a.href = sampleFileUrl;
        a.setAttribute("download", sampleFileUrl);
        a.click();
    }

    const handleUpload = (file: any, isValid: boolean) => {
        if (isValid) {
            setUploadedFile(file);
        }
        else {
            Toast(t('F104'), 'error');
        }
    };

    const importBody = () => {
        return (
            <div className={Styles.container}>
                {isIndiaUser &&
                    <MultiSelectCheckBox
                        label={t('tabSenderId')}
                        placeholder={t('tabSenderId')}
                        options={getSenderIdOptions()}
                        onChange={(e: any) => setImportMultiselectValue([...e])}
                        value={importMultiselectValue}
                        maxTagCount={4}
                        searchString={t('mainSearch')}
                    />
                }
                {isEmpty(uploadedFile) &&
                    <>
                        <DragDrop onChange={(files: any, isValid: boolean) => { handleUpload(files, isValid) }}
                            placeholders={[t('RBC2077'), t('RBC2078'), t('RBC2079')]}
                            fileFormats={'.xls, .csv, .xlsx'} />
                        <span className={Styles.dragDropText}>{t('BLD01600')}</span>
                    </>}
                {!isEmpty(uploadedFile) &&
                    <Attachment
                        id={uploadedFile[0].name}
                        fileName={uploadedFile[0].name}
                        fileType={(uploadedFile[0].name).split('.').pop() || ''}
                        closable={true}
                        onClose={() => { setUploadedFile([]) }}
                        showImage={false} />}
                {isEmpty(uploadedFile) && <div className={Styles.alignRight}>
                    <Button
                        type="link"
                        onClick={downloadSampleReport}
                        icon={<img src={DownloadIcon} alt={'download'} />}
                        iconPosition="left"><span className={Styles.downloadBtnText}>{t('camDownloadSampleFile')}</span>
                    </Button>
                </div>}
            </div>
        )
    };

    const getBody = () => {
        return (
            <div className={Styles.container}>

                <Input
                    bordered={true}
                    placeholder={t('mainTitle')}
                    label={t('mainTitle')}
                    value={title}
                    onChange={(e: any) => setTitle(e.target.value)}
                    className={Styles.inputField}
                    showBottomLabelSpace={false}
                />
                <Tooltip title={purposeTooltipBody()} placement="left" trigger={['click']} style={{ width: '222px' }}>
                    <Select
                        label={t('assetsWidgetPurpose')}
                        placeholder={t('assetsWidgetPurpose')}
                        options={purposeOption()}
                        value={purpose ? purpose.value : undefined}
                        onChange={(val: any, key: any) => setPurpose(key)}
                        className={Styles.inputField}
                        showBottomLabelSpace={false}
                        showSearch
                    >
                    </Select>
                </Tooltip>
                {
                    isIndiaUser &&
                    <Select
                        label={t('verifySenderID')}
                        placeholder={t('verifySenderID')}
                        options={senderIdOption()}
                        value={senderId ? senderId.value?.replace(/ /g, "\u00A0") : undefined}
                        onChange={(val: any, key: any) => setSenderId(key)}
                        className={Styles.inputField}
                        showBottomLabelSpace={false}
                        showSearch
                    >
                    </Select>
                }
                {
                    isIndiaUser &&
                    <Input
                        bordered={true}
                        placeholder={t('verifyTemplateId')}
                        label={t('verifyTemplateId')}
                        value={templateId}
                        onChange={(e: any) => setTemplateId(e.target.value)}
                        showBottomLabelSpace={false}
                        style={{ marginBottom: '-0.25rem' }}
                        bottomLabelType={templateIdStatus()}
                    />
                }
                <div className={Styles.textBox}>
                    <TextArea
                        placeholder={t('KLR00104')}
                        label={t('KLR00104')}
                        style={{ height: '8rem', paddingBottom: '3rem' }}
                        value={textContent}
                        onChange={(e) => setTextContent(e.target.value)}
                        showDetailsFooter={true}
                        showMessageCount={true}
                        showAttachmentOption={true}
                        showInsertLinkOption={true}
                        characterLimit={4000}
                        showBottomLabelSpace={false}
                        onInsertLink={() => setShowSideModal(true)}
                        onAttach={(file: any) => handleAttachFile(file)}
                        textLength={textareaCharCount}
                        msgCountProp={messageUnitsCount}
                        getText={(text: string) => {
                            const { count, units } = getcharcount(text);
                            setTextareaCharCount(count);
                            setMessageUnitsCount(units);
                        }}
                    />
                </div>
                {showSideModal && <Slider
                    containerId="root-modal"
                    visibility={showSideModal}
                    onClose={() => { setUrlShortenerText(''); setShowSideModal(false) }}
                    title={t('KLR00105')}
                    footer={getURLShortenerFooter()}
                >
                    <div className={Styles.container}>
                        <Input
                            label={t('KLR00106')}
                            placeholder={t('KLR00106')}
                            value={urlShortenerText}
                            bottomLabelType={isValidUrl() ? "default" : "error"}
                            onChange={(e: any) => setUrlShortenerText(e.target.value)}
                        />
                    </div>
                </Slider>}
            </div>
        )
    }

    return (
        <Slider
            containerId="root-modal"
            visibility={true}
            onClose={onClose}
            footer={getMainFooter()}
            title={t('KLR00107')}
            containerClassName={Styles.rootContainer}
            tabs={[{ "label": t('mainImport'), "value": "import" }, { "label": t('KLR00405'), "value": "new" }]}
            initActiveTab="import"
            onTabClick={(tab: string) => setSelectedTab(tab as tabOptionstype)}
        >
            {selectTabBody()}
        </Slider>
    );

};


export default TemplateApplyForm;